import React from "react";
import { Link } from "react-router-dom";
import Container from "./layout/Container";

const PublicHero = ({
  eyebrow,
  title,
  subtitle,
  mobileSubtitle,
  button,
  imageSrc,
  imageAlt = "",
  imageClassName = "object-center",
  backgroundClass = "",
  compact = false,
}) => {
  const shellClassName = compact
    ? "relative min-h-[430px] md:h-[500px] flex items-center overflow-hidden border-b border-mmBorder"
    : "relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden border-b border-mmBorder";
  const containerClassName = compact
    ? "relative z-10 py-14 md:py-14"
    : "relative z-10 py-16 md:py-20";
  const titleClassName = compact
    ? "font-display uppercase tracking-[0.08em] sm:tracking-widest text-white text-[32px] md:text-[54px] leading-[0.98] break-words max-w-full"
    : "font-display uppercase tracking-[0.08em] sm:tracking-widest text-white text-[34px] sm:text-[42px] md:text-[76px] leading-[0.98] break-words max-w-full";
  const accentClassName = compact
    ? "h-[3px] w-12 bg-mmAccent rounded-full mt-5 mb-6 md:mt-4 md:mb-5"
    : "h-[3px] w-20 bg-mmAccent rounded-full my-6";
  const subtitleClassName = compact
    ? "text-white/95 text-[15px] md:text-lg leading-relaxed whitespace-pre-line"
    : "text-white/95 text-base md:text-xl leading-relaxed whitespace-pre-line";

  return (
    <section
      className={`${shellClassName} ${
        imageSrc ? "" : backgroundClass
      }`}
    >
      {imageSrc && (
        <img
          src={imageSrc}
          alt={imageAlt}
          className={`absolute inset-0 h-full w-full object-cover ${imageClassName}`}
          width={1200}
          height={800}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      )}
      <div className="absolute inset-0 mm-heroOverlay" />
      <div className="absolute inset-0 bg-black/25 md:bg-black/10" />

      <Container className={containerClassName}>
        <div className="w-full max-w-4xl">
          {eyebrow && (
            <p className="font-display uppercase tracking-[0.18em] text-mmAccent text-sm md:text-base mb-5 md:mb-4">
              {eyebrow}
            </p>
          )}
          <h1 className={titleClassName}>
            {title}
          </h1>
          <div className={accentClassName} />
          {subtitle && (
            <div className="w-full max-w-2xl bg-black/65 border border-white/10 rounded-2xl px-5 py-4 shadow-sm md:px-6 md:py-5">
              <div className={`${subtitleClassName} md:hidden`}>
                {mobileSubtitle || subtitle}
              </div>
              <div className={`${subtitleClassName} hidden md:block`}>
                {subtitle}
              </div>
            </div>
          )}
          {button && (
            <div className="mt-9 md:mt-8">
              <Link to={button.to}>
                <button className="mm-btnPrimary px-8">
                  {button.label}
                </button>
              </Link>
            </div>
          )}
        </div>
      </Container>
    </section>
  );
};

export default PublicHero;
